import React from "react";
export default function StaffListRowPicker(props) {
  let values = [];
  for (let field in props) values.push(field);

  let literal = props["fullname"] ? props["fullname"][0].toUpperCase() : null;
  let literalBg = "bg-light";
  if (props.lock_date) literalBg = "bg-light-danger";

  const info = props.info || {};

  const onPick = () => {
    if (props.onStaffPick) {
      props.onStaffPick(props);
    }
  };

  return (
    <div
      className="py-4 px-2 cursor-pointer border-bottom text-dark list-item no-select"
      onDoubleClick={onPick}
    >
      <div className="d-flex justify-content-start align-items-center">
        <div className="symbol symbol-20 symbol-lg-40 mr-3 align-middle">
          {info.picture ? (
            <img alt="userpic" src={info.picture} />
          ) : (
            <span className={`symbol-label ${literalBg}`}>{literal}</span>
          )}
        </div>
        <div>
          {props.fullname}
          <div className="small mt-1">
            {props.positionname && (
              <span className="text-dark-75 mr-2 nowrap d-inline-block">
                {props.positionname}
              </span>
            )}
            {props.areaname && (
              <span className="text-dark-50 mr-2 nowrap d-inline-block">
                {props.areaname}
              </span>
            )}
            {props.structurename && (
              <span className="text-dark-50 mr-2 nowrap d-inline-block">
                {props.structurename}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
